module.exports = __webpack_public_path__ + "static/media/canLeadToHeartAttack.2a885115.mp3";